import React, { useEffect, useRef, useContext, useState } from "react";
import PropTypes from "prop-types";
import { FontSizeContext } from "../../context/fontSizeContext";
import SectionTitle from "../../components/section-title";

const PartnersContainer = ({ contRef }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const [videoSrc, setVideoSrc] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeButtonRef = useRef(null);
    const previousFocusRef = useRef(null);
    const modalContentRef = useRef(null);
    const scrollYRef = useRef(0);

    const openModal = (data, triggerEl) => {
        previousFocusRef.current = triggerEl;
        if (data == 0) {
            setVideoSrc([
                "Nodal Grievance Redressal Officer",
                "",
                "022-69581104",
                "GRO@smfgindia.com",
                "SMFG India Credit Co. Ltd. Ground Floor, Embassy 247, Lal Bahadur Shastri Marg, Gandhi Nagar, Vikhroli (West), Mumbai, Maharashtra – 400083",
                "https://www.smfgindiacredit.com/digital-lending-partner.aspx",
            ]);
        } else {
            setVideoSrc([
                "Grievance Redressal Officer",
                "Mr. Vaseem Khan",
                "+91 91159 98000 / +91 22 3043 3020",
                "Grievance.sme@ambit.co",
                "Kanakia Wall Street - 5th floor, A 506-510, Andheri-Kurla Road, Andheri East, Mumbai, Maharashtra - 400093",
                "https://finvest.ambit.co/",
            ]);
        }
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setVideoSrc("");
    };

    // useEffect(() => {
    //     if (isModalOpen) {
    //         setVideoSrc(
    //             "https://www.youtube.com/embed/oUZnCGZpLyU?si=hjVgsQtFHyANoGb6&autoplay=1"
    //         );
    //     } else {
    //         setVideoSrc(""); // Stop video when modal is closed
    //     }
    // }, [isModalOpen]);

    useEffect(() => {
        if (isModalOpen) {
            // setVideoSrc(
            //     "https://www.youtube.com/embed/oUZnCGZpLyU?si=hjVgsQtFHyANoGb6&autoplay=1"
            // );
            scrollYRef.current = window.scrollY;
            document.body.style.position = "fixed";
            document.body.style.top = `-${scrollYRef.current}px`;
            document.body.style.left = "0";
            document.body.style.right = "0";
            document.body.style.width = "100%";

            const focusTimeout = setTimeout(() => {
                closeButtonRef.current?.focus();
            }, 100);
            return () => clearTimeout(focusTimeout);
        } else {
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.left = "";
            document.body.style.right = "";
            document.body.style.width = "";
            window.scrollTo(0, scrollYRef.current);

            previousFocusRef.current?.focus();
            setVideoSrc(""); // Stop video when modal is closed
        }

        return () => {
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.left = "";
            document.body.style.right = "";
            document.body.style.width = "";
        };
    }, [isModalOpen]);

    useEffect(() => {
        if (!isModalOpen) return;

        const modalNode = modalContentRef.current;
        if (!modalNode) return;

        const focusableSelector =
            'a[href], button:not([disabled]), textarea, input, select, iframe, [tabindex]:not([tabindex="-1"])';

        const getFocusable = () =>
            Array.from(modalNode.querySelectorAll(focusableSelector)).filter(
                (el) => el.offsetParent !== null
            );

        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                closeModal();
                return;
            }

            if (e.key !== "Tab") return;

            const focusable = getFocusable();
            if (focusable.length === 0) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const active = document.activeElement;

            if (e.shiftKey) {
                if (active === first || !modalNode.contains(active)) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (active === last || !modalNode.contains(active)) {
                    e.preventDefault();
                    first.focus();
                }
            }
        };

        // Safety net: if focus ever ends up outside the modal, pull it back
        const handleFocusIn = (e) => {
            if (!modalNode.contains(e.target)) {
                closeButtonRef.current?.focus();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("focusin", handleFocusIn);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("focusin", handleFocusIn);
        };
    }, [isModalOpen]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    // Files in the public folder are served from the root URL "/"
    useEffect(() => {
        fetch("../../data/partners.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch JSON");
                }
                return response.json();
            })
            .then((jsonData) => {
                setData(jsonData);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error loading JSON:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);
    return (
        <div className="single-service section-py" ref={contRef}>
            {data.map((single, i) => {
                return (
                    <div className="container custom-container mb-10" key={i}>
                        <div className="row g-0 align-items-center">
                            <div className="col-xl-6 col-lg-8 mx-auto  text-center">
                                <SectionTitle
                                    classOption="title-section"
                                    subTitle=""
                                    title={single.name}
                                    excerptClassOption="mb-5"
                                    excerpt=""
                                />
                            </div>
                            <div className="col-12">
                                <div
                                    id="grid"
                                    className="grid row mb-n7 justify-content-center"
                                >
                                    {single.image.map((item, i) => {
                                        if (!single.isInfo) {
                                            return (
                                                <div
                                                    className="grid-item mb-7 text-center"
                                                    key={i}
                                                >
                                                    <div className="grid-item-padding feature-card bg-light">
                                                        <img
                                                            style={{
                                                                maxHeight:
                                                                    "75px",
                                                            }}
                                                            className="logo"
                                                            src={
                                                                process.env
                                                                    .PUBLIC_URL +
                                                                item.img
                                                            }
                                                            alt={`LOGO OF ${item.name}`}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        } else {
                                            return (
                                                <div
                                                    className="grid-item mb-7 text-center focus-visible-outline"
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                    key={i}
                                                    onClick={(e) => {
                                                        openModal(
                                                            i,
                                                            e.currentTarget
                                                        );
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (
                                                            e.key === "Enter" ||
                                                            e.key === " "
                                                        ) {
                                                            e.preventDefault();
                                                            openModal(
                                                                i,
                                                                e.currentTarget
                                                            );
                                                        }
                                                    }}
                                                    role="button"
                                                    tabIndex={0}
                                                >
                                                    <div className="grid-item-padding feature-card bg-light">
                                                        <img
                                                            style={{
                                                                maxHeight:
                                                                    "75px",
                                                            }}
                                                            className="logo"
                                                            src={
                                                                process.env
                                                                    .PUBLIC_URL +
                                                                item.img
                                                            }
                                                            alt={`LOGO OF ${item.name}`}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
            <div
                className={`modal ${isModalOpen ? "show" : ""}`}
                style={{
                    display: isModalOpen ? "block" : "none",
                    background: "#b5c4a875",
                }}
                role="dialog"
                aria-modal="true"
                aria-labelledby={videoSrc[0]}
                id={"modal " + videoSrc[0]}
                tabIndex={-1}
            >
                <div
                    className="modal-dialog modal-dialog-centered modal-lg"
                    style={{
                        borderRadius: "0.75em",
                    }} // Adjust modal width
                >
                    <div ref={modalContentRef} className="modal-content">
                        {/* Close button */}
                        <button
                            type="button"
                            className="btn-close custom-close-button"
                            style={{
                                position: "absolute",
                                top: "-15px",
                                right: "-5px",
                                backgroundColor: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: "50%",
                                padding: "5px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                zIndex: 1050,
                                width: "25px",
                                height: "25px",
                            }}
                            aria-label="Close"
                            onClick={closeModal}
                        ></button>

                        <div className="modal-body p-5">
                            <div className="row justify-content-center">
                                <div className="col-md-10">
                                    <h2
                                        className="text-center fs-4"
                                        id={videoSrc[0]}
                                    >
                                        <b>{videoSrc[0]}</b>
                                    </h2>
                                    <table
                                        style={{ border: "2px solid green;" }}
                                    >
                                        <caption className="fs-16">
                                            {`Contact details of the ${videoSrc[0]}`}
                                        </caption>

                                        <tbody>
                                            {videoSrc[1] != "" ? (
                                                <tr>
                                                    <th
                                                        scope="row"
                                                        // style={{
                                                        //     border: "2px solid green",
                                                        // }}
                                                    >
                                                        Name
                                                    </th>
                                                    <td
                                                    // style={{
                                                    //     border: "2px solid green",
                                                    // }}
                                                    >
                                                        {videoSrc[1]}
                                                    </td>
                                                </tr>
                                            ) : (
                                                ""
                                            )}
                                            <tr>
                                                <th scope="row">Phone No</th>
                                                <td>{videoSrc[2]}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Email Id</th>
                                                <td>
                                                    <a
                                                        href={
                                                            "mailto:" +
                                                            videoSrc[3]
                                                        }
                                                        className="text-decoration-underline"
                                                    >
                                                        {videoSrc[3]}
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Adderess</th>
                                                <td>{videoSrc[4]}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Website</th>
                                                <td>
                                                    <a
                                                        href={videoSrc[5]}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="text-decoration-underline"
                                                    >
                                                        {videoSrc[5]}
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PartnersContainer.propTypes = {
    data: PropTypes.array,
    contRef: PropTypes.any,
};

export default PartnersContainer;
